module.exports = __webpack_public_path__ + "static/img/选中.62c2775e.png";